import { render, staticRenderFns } from "./SliderAndInput.vue?vue&type=template&id=71c0c531&scoped=true&"
import script from "./SliderAndInput.vue?vue&type=script&lang=js&"
export * from "./SliderAndInput.vue?vue&type=script&lang=js&"
import style0 from "./SliderAndInput.vue?vue&type=style&index=0&id=71c0c531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c0c531",
  null
  
)

export default component.exports